<template>
  <g>
    <circle
      cx="10"
      cy="10"
      r="8.5"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
    <path
      d="M6 10L8.5 12.5L14 7"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
  </g>
</template>

<script>
export default {
  name: 'IconSuccess',
}
</script>
